import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
import { useNavigate } from "react-router-dom";
import classes from "./Drafts.module.scss";
import TableArea from "../../aquaDrafts/TableArea";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../aquaDrafts/commons/theme";
import ScrollButton from "../../aquaDrafts/atoms/ScrollButton";
import {
  backgroundColor,
  backgroundColorDrafts,
} from "../../../commons/colors";

const Main = () => {
  const user = useRecoilValue(userState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.isAuth) {
      navigate("/login");
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <div>
        <div
          className={classes.login}
          style={backgroundColorDrafts(user?.mode ?? "lite")}
        >
          <div className={classes.loginWrapper}>
            <TableArea />
            <ScrollButton />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Main;
